module.exports = __webpack_public_path__ + "d3ab6c2834d8cd2715fedcb2771b8ecf.svg";